/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useCallback, useEffect, useState} from 'react';
import {
  FlatList,
  RefreshControl,
  InteractionManager,
  SafeAreaView,
  StyleSheet,
  View,
  useWindowDimensions,
  Platform,
} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import {
  Button,
  Card,
  Divider,
  Icon,
  IconButton,
  List,
  Text,
} from 'react-native-paper';
import {errorHandler, prepareDataForFlatList} from '../services/Utils';
import {theme} from '../theme/theme';
import moment from 'moment';
import {DatePickerModal} from 'react-native-paper-dates';
import {printSalesReport} from '../services/PrintService';
import * as BluetoothPrintService from '../services/BluetoothPrintService';
import {showToast} from '../store/info.slice';
import {ReportsApiService} from '../services/ReportsApiService';

const getNumColumns = width => {
  if (width < 500) {
    return 1;
  }
  if (width < 576) {
    return 2;
  }
  if (width < 768) {
    return 2;
  }
  if (width < 992) {
    return 3;
  }
  if (width < 1200) {
    return 4;
  }
  if (width < 1400) {
    return 5;
  }
  return 5;
};

function SalesReport({navigation}) {
  const {width} = useWindowDimensions();
  const dispatch = useDispatch();
  const numColumns = getNumColumns(width);
  const canteens = useSelector(state => state.cafe.canteens);
  const customer = useSelector(state => state.customer?.customer);
  const [interactionCompleted, setIntersectionCompleted] = useState(false);
  const [report, setReport] = useState([]);
  const [refreshing, setRefreshing] = useState(false);
  const [salesInfo, setSalesInfo] = useState(null);
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const [selectedDate, setSelectedDate] = useState(today);
  const [openDatePicker, setOpenDatePicker] = useState(false);

  const onDismissSingle = useCallback(() => {
    setOpenDatePicker(false);
  }, [setOpenDatePicker]);

  const onConfirmSingle = React.useCallback(
    params => {
      setOpenDatePicker(false);
      setSelectedDate(params.date);
    },
    [setOpenDatePicker, setSelectedDate],
  );

  const fetchSalesInfo = () => {
    ReportsApiService.get('/cash-counter/sale-info', {
      params: {date: moment(selectedDate).format('YYYY-MM-DD')}
    })
      .then(response => {
        setSalesInfo(response.data);
      })
      .catch(_error => {
        console.log('Error fetching sales info', _error);
        errorHandler(_error);
      });
  };

  const fetchData = ({action = 'view', format = 'json'} = {}) => {
    setRefreshing(false);
    let params = {
      action,
      format,
      date: moment(selectedDate).format('YYYY-MM-DD'),
    };
    ReportsApiService.get('/cash-counter/sale-report', {params: {...params}})
      .then(response => {
        if (action === 'download') {
          if (response.data?.length === 0) {
            return dispatch(showToast('No data available to print'));
          }
          const report_params = {
            report_name: 'Sales Report',
            cafe_name: customer?.cafe_name,
            login_at: customer?.logged_in_time
              ? moment(customer.logged_in_time).format('llll')
              : moment().format('llll'),
            canteen_name:
              canteens?.length === 1 ? canteens[0]?.canteen_name : 'All',
            reporting_time: moment().format('llll'),
            items: response.data,
            customer_name: `${customer?.cust_name ?? ''} ${customer?.cust_last_name ?? ''}`.trim(),
          };
          if (Platform.OS === 'web') {
            printSalesReport(report_params);
          } else if (Platform.OS === 'android') {
            BluetoothPrintService?.printSalesReport(report_params);
          }
          return;
        }
        setRefreshing(false);
        fetchSalesInfo();
        setReport(
          prepareDataForFlatList({
            numColumns,
            key: 'cc_pm_id',
            page: 1,
            data: response.data,
          }),
        );
      })
      .catch(_error => {
        console.log('Error fetching sales report', _error);
        setRefreshing(false);
        errorHandler(_error);
      });
  };

  useEffect(() => {
    const task = InteractionManager.runAfterInteractions(async () => {
      setIntersectionCompleted(true);
    });
    return () => {
      task.cancel();
    };
  }, []);

  useEffect(() => {
    if (interactionCompleted) {
      fetchData();
    }
  }, [interactionCompleted, selectedDate]);

  const renderItem = ({item, index}) => {
    if (item?.isEmpty) {
      return <View style={{flex: 1}} />;
    }
    return (
      <List.Item
        style={{backgroundColor: '#fff', margin: 2, flex: 1}}
        title={item?.cc_pm_name}
        titleStyle={{fontSize: 12}}
        right={props => (
          <View style={{alignItems: 'center'}}>
            <Text variant="titleSmall" style={{fontSize: 12}}>
              {customer?.currency_symbol}
              {item?.grand_total}
            </Text>
          </View>
        )}
        description={
          <View>
            <Text style={{fontSize: 12}}>Orders: {item?.total_orders}</Text>
          </View>
        }
      />
    );
  };

  const _refreshControl = () => {
    return (
      <RefreshControl
        colors={[theme.colors.primary]}
        refreshing={refreshing}
        onRefresh={() => _onRefresh()}
      />
    );
  };

  const _onRefresh = () => {
    fetchData();
  };

  const ListHeaderComponent = () => {
    return (
      <React.Fragment>
        {salesInfo && (
          <Card
            elevation={0}
            style={{
              marginBottom: 2,
              borderRadius: 0,
              backgroundColor: '#ffffff',
            }}>
            <Card.Title
              title="Cash Counter"
              subtitle={moment(selectedDate).format('MMMM D, YYYY')}
              //   right={props => (
              //     <IconButton
              //       icon={'calendar-range'}
              //       onPress={() => setOpenDatePicker(t => !t)}
              //     />
              //   )}
            />
            <Divider style={{backgroundColor: '#dddddd'}} />
            <Card.Title
              title={
                <List.Item
                  left={() => (
                    <View style={{alignItems: 'center'}}>
                      <Icon
                        source={'cash'}
                        size={32}
                        color={theme.colors.primary}
                      />
                    </View>
                  )}
                  title={
                    customer?.currency_symbol + '' + salesInfo?.total_amount
                  }
                  description="Amount Collected"
                  style={{borderRadius: 4, flex: 1, backgroundColor: '#ffffff'}}
                />
              }
              right={props => (
                <List.Item
                  left={() => (
                    <View style={{alignItems: 'center'}}>
                      <Icon
                        source={'cube-outline'}
                        color={theme.colors.primary}
                        size={32}
                      />
                    </View>
                  )}
                  title={salesInfo?.total_orders}
                  description="Total Orders"
                  style={{borderRadius: 4, flex: 1, backgroundColor: '#ffffff'}}
                />
              )}
            />
          </Card>
        )}
      </React.Fragment>
    );
  };

  return (
    <SafeAreaView style={styles.container}>
      {interactionCompleted && (
        <React.Fragment>
          <View style={styles.mainContainer}>
            <FlatList
              data={report}
              renderItem={renderItem}
              keyExtractor={(item, index) => (item?.cc_pm_id).toString()}
              refreshControl={_refreshControl()}
              ListHeaderComponent={ListHeaderComponent}
              key={numColumns}
              numColumns={numColumns}
              columnWrapperStyle={numColumns > 1 ? {gap: 1} : undefined} // RN 0.71+
              contentContainerStyle={{padding: 4}}
            />
            {/* <DatePickerModal
                            locale="en"
                            mode="single"
                            validRange={{ endDate: today }}
                            visible={openDatePicker}
                            onDismiss={onDismissSingle}
                            date={selectedDate}
                            onConfirm={onConfirmSingle}
                            presentationStyle={'pageSheet'}
                            saveLabel={'Submit'}
                        /> */}
          </View>
          {customer?.customer_settings?.enable_printing_sales_report &&
            Platform.OS !== 'web' && (
              <View style={styles.footer}>
                <Button
                  mode="contained"
                  style={{margin: 4}}
                  onPress={() => fetchData({action: 'download'})}>
                  Print
                </Button>
              </View>
            )}
        </React.Fragment>
      )}
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f1f1f3',
  },
  mainContainer: {
    flex: 1,
    marginVertical: 0,
  },
  footer: {
    position: Platform.OS === 'web' ? 'sticky' : undefined,
    bottom: 0,
    width: '100%',
  },
});

export default SalesReport;
